const accessAppVersion = {

    UPDATE_VERSION: {
        path: '/update-version'
    },

}

export default accessAppVersion;
